import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Select } from '~/eds/src/components/Select/Select';
import { useIntl } from 'react-intl';
import { getConditionOptions } from '~/reducers/workflow';

function ConditionSelect({
  value,
  onChange,
  // connected
  options,
  shouldValidate,
}) {
  const intl = useIntl();
  let error;
  if (shouldValidate) {
    if (value == null) {
      error = intl.formatMessage({
        id: 'ConditionSelect.missingCondition',
        defaultMessage: 'Missing Condition',
        description: 'Error message when no condition is selected',
      });
    } else if (!options.find((option) => option.value === value)) {
      error = intl.formatMessage({
        id: 'ConditionSelect.invalidCondition',
        defaultMessage: 'Invalid Condition',
        description: 'Error message when selected condition is invalid',
      });
    }
  }

  return (
    <Select
      error={error}
      options={options}
      enablePortal={true}
      placeholder={
        error ||
        intl.formatMessage({
          id: 'ConditionSelect.placeholder',
          defaultMessage: 'Condition',
          description: 'Placeholder text for condition selection',
        })
      }
      value={value}
      width="input.l.width"
      onChange={onChange}
    />
  );
}

ConditionSelect.propTypes = {
  /** selected item's value */
  value: PropTypes.any,
  /** callback that returns newly selected party id */
  onChange: PropTypes.func.isRequired,
};

function mapStateToProps({ builder, workflow }) {
  return {
    options: getConditionOptions(workflow),
    shouldValidate: builder.shouldValidate,
  };
}

export default connect(mapStateToProps)(ConditionSelect);
